module.exports = __webpack_public_path__ + "stylesheets/_typography_7d99e03223012e618de7f8151c51f31b.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/_typography.less
// module id = wJnc
// module chunks = 153